import { UploadFileIcon } from "components/ui/icons/generalFeedback/UploadFileIcon"
import type { DropzoneState } from "react-dropzone"
import style from "./ImageDropzone.module.scss"

const { dragAnDropZone, imageActive, text, wrapper } = style

type Props = Pick<DropzoneState, "getRootProps" | "getInputProps" | "isDragActive"> & { className?: string }

export const ImageDropzone = ({ getRootProps, getInputProps, isDragActive, className = "" }: Props) => {
	return (
		<div {...getRootProps()} className={`${dragAnDropZone} ${isDragActive ? imageActive : ""} ${className}`}>
			<input {...getInputProps()} />
			<div className={wrapper}>
				<UploadFileIcon />
				<div className={text}>
					<span>Upload</span> or drop image here
				</div>
			</div>
		</div>
	)
}
